import { api } from '@/config/api';

export interface MetaObjective {
  code: string;
  label: string;
  description: string;
}

export interface MetaBidStrategy {
  code: string;
  label: string;
  description?: string;
}

export interface MetaOptimizationGoal {
  code: string;
  label: string;
}

export interface MetaOptionsResponse {
  objectives: MetaObjective[];
  bidStrategies: MetaBidStrategy[];
  billingEvents: Array<{ code: string; label: string }>;
  optimizationGoals: Record<string, MetaOptimizationGoal[]>;
  ctaTypes: Array<{ code: string; label: string }>;
  specialAdCategories: Array<{ code: string; label: string }>;
  ageMin: number;
  ageMax: number;
  genders: Array<{ code: number; label: string }>;
}

export interface GeoSearchResult {
  key: string;
  name: string;
  type: string;
  country_code?: string;
  country_name?: string;
  region?: string;
  region_id?: string;
  supports_region?: boolean;
  supports_city?: boolean;
}

export interface InterestSearchResult {
  id: string;
  name: string;
  audience_size_lower_bound?: number;
  audience_size_upper_bound?: number;
  path?: string[];
  topic?: string;
}

export const facebookMetaOptionsService = {
  get: async (): Promise<MetaOptionsResponse> =>
    (await api.get('/slighter_crm/facebook/meta-options')).data,

  searchCountries: async (q: string): Promise<GeoSearchResult[]> =>
    (await api.get('/slighter_crm/facebook/targeting/search/countries', { params: { q } })).data,

  searchCities: async (q: string, country_code?: string): Promise<GeoSearchResult[]> =>
    (await api.get('/slighter_crm/facebook/targeting/search/cities', { params: { q, country_code } })).data,

  searchRegions: async (q: string, country_code?: string): Promise<GeoSearchResult[]> =>
    (await api.get('/slighter_crm/facebook/targeting/search/regions', { params: { q, country_code } })).data,

  searchInterests: async (q: string): Promise<InterestSearchResult[]> =>
    (await api.get('/slighter_crm/facebook/targeting/search/interests', { params: { q } })).data,
};
